<template>
  <button @click.stop="$emit('button-clicked')" :disabled="disabled" :class="type">{{ label }}</button>
</template>

<script>
export default {
  name: "Button",
  props: {
    type: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    }
  }
};
</script>

<style  scoped>
button {
  width: 190px;
  height: 40px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 16px;
  border: none;

}
button :focus {
    outline: none;
  }
.primary {
  background-color: #9178a0;
}
.secondary {
  background-color: #cba8e0;
}
</style>



// WEBPACK FOOTER //
// src/components/Button.vue